export const getIvtList = (state) => state.ivt.list;
export const getIvtFilters = (state) => state.ivt.filters;
